<template>
  <main class="page">
    <section class="section page__header">
      <h1 class="title">Договоры</h1>
    </section>

    <section class="section page__content">
      <div class="page__row page__row_between mb-40">
        <div class="page__row">
          <div class="page__item user-list__search page__search">
            <SearchForm :value="searchValue" @form-submit="setSearchValue" />
          </div>

          <AppButtonFilter
            :active="filterIsActive"
            @click.native="toggleFilter"
          />
          <div class="page__item page__export">
            <AppButtonSmExport
              title="Экспорт"
              type="main"
              @click.native="downloadExcel"
            />
          </div>
        </div>
        <div class="table__buttons">
            <transition name="fade" v-if="roleAccessRemove">
                <AppButtonSmRemove
                  style="margin-right: 20px"
                  v-if="isActiveDelete"
                  title="Удалить"
                  @click.stop.native="showRemoveConfirmationGroup"
                />
            </transition>
            <AppButtonSmAdd v-if="roleAccessCreate"
              title="Создать"
              @click.stop.native="goToUpdateContract('create')"
            />
        </div>
      </div>

      <transition name="fade">
        <Form
          v-model="filterData"
          :value="filter"
          @request="setFilter"
          ref="filterForm"
          v-if="filterIsActive"
          class="filter"
        >
          <div class="filter__list">
            <AppSelect
              title="Контрагент"
              :options="contractorOptionList"
              newItemFromSearch
              placeholder="Не выбрано"
              name="contractor"
              @search-changed="searchContractor"
            />

            <AppSelect
              title="Проект"
              :options="projectOptionList"
              newItemFromSearch
              placeholder="Не выбрано"
              name="project"
              @search-changed="searchProject"
            />
            <VInput name="contractNumber" label="Номер договора" />
            <AppSelect
              title="Тип договора"
              :options="typeOptionList"
              newItemFromSearch
              placeholder="Не выбрано"
              name="type"
            />
            <AppInputDate name="startDate" title="Дата начала" />
            <AppInputDate name="endDate" title="Дата окончания" />
            <VInput name="sum" label="Сумма" />
            <AppSelect
              title="Стадия"
              :options="stageOptionList"
              newItemFromSearch
              placeholder="Не выбрано"
              name="stage"
            />
            <AppSelect
              title="Статус"
              :options="statusOptionList"
              newItemFromSearch
              placeholder="Не выбрано"
              name="status"
            />
            <AppSelect
              title="Ответсвенный"
              :options="assigneeOptionList"
              newItemFromSearch
              placeholder="Не выбрано"
              name="assignee"
            />
          </div>
          <div class="filter__buttons">
            <AppButton
              type="main"
              title="Показать"
            />
            <AppButton
              type="alt"
              title="Сбросить"
              @click.stop.native="clearFilter"
            />
          </div>
        </Form>
      </transition>

      <div class="page__row page__table mb-20" v-if="contracts.length !== 0">
        <AppTable
          :data="contracts"
          :headers="tableHeader"
          :has-checkbox="roleAccessRemove"
          :all-items-active="tableHeader.allActive"
          :isMenuControlsActive="false"
          :isSpecial="true"
          :loading="isLoading"
          @toggle-active-item="toggleActiveItem"
          @toggle-active-all="toggleActiveAll"
          @edit-this-item="goToUpdateContract"
          @save-item-info="saveContractItem"
          @remove-this-item="showRemoveConfirmation"
          @show-this-item="goToUpdateContract"
        />
      </div>
      <div class="page__row mb-20" v-else>
        <div class="no-records">
          <AppNoRecordsPlaceholder text="Записи не найдены" />
        </div>
      </div>
    </section>
    <section class="section page__footer user-list__footer">
      <div class="page__row" v-if="pagination.lastPage > 1">
        <VPagination
          :pageList="pagination.pageList"
          :currentPage="pagination.currentPage"
          @get-page="getPage"
        />
      </div>
    </section>

    <transition name="fade">
      <AppConfirmation
        v-if="removeConfirmation.active"
        :text="
          removeConfirmation.group
            ? 'Вы действительно хотите удалить эти договора?'
            : 'Вы действительно хотите удалить этот договор?'
        "
        @confirm="
          removeConfirmation.group ? deleteContractsChecked() : removeContract()
        "
        @reject="closeModalRemove"
      />
      <AppModal
        v-if="deleteResponseModal.isActive"
        :title="deleteResponseModal.title"
        :text="deleteResponseModal.text"
        confirmButtonTitle="Ок"
        :confirmButtonType="deleteResponseModal.type"
        @confirm="closeDeleteModal"
      />
    </transition>
  </main>
</template>

<script>
import SearchForm from '@/components/page/input/SearchForm'
import AppButtonSmAdd from '@/components/page/button/AppButtonSmAdd'
import AppTable from '@/components/page/table/AppTable'
import AppNoRecordsPlaceholder from '@/components/page/text/AppNoRecordsPlaceholder'
import AppConfirmation from '@/components/page/modal/AppConfirmation'
import AppModal from '@/components/page/modal/AppModal'
import AppButtonSmRemove from '@/components/page/button/AppButtonSmRemove'
import AppButtonSmExport from '../../components/page/button/AppButtonSmExport'
import AppInputDate from '@/components/page/input/AppInputDate'
import AppSelect from '@/components/page/input/AppSelect'
import VInput from '@/components/page/Form/Vinput/Vinput.vue'
import VPagination from '@/components/page/VPagination'
import AppButton from '@/components/page/button/AppButton'
import AppButtonFilter from '@/components/page/button/AppButtonFilter'
import Form from '@/components/page/Form/Form'
import { mapGetters } from 'vuex'

export default {
  name: 'ContractList',
  components: {
    AppButtonSmExport,
    AppConfirmation,
    AppNoRecordsPlaceholder,
    AppTable,
    AppButtonSmAdd,
    SearchForm,
    AppButtonSmRemove,
    AppModal,
    AppInputDate,
    AppSelect,
    VInput,
    VPagination,
    AppButtonFilter,
    AppButton,
    Form
  },
  data () {
    return {
      removeConfirmation: {
        active: false,
        id: null,
        group: false
      },
      // фильтр
      filterIsActive: false,
      filterData: {}
    }
  },
  computed: {
    ...mapGetters('contractListPage', [
      'getContractsList',
      'getContractsListActiveDelete',
      'getContractsListFilter',
      'getContractListIsLoading',
      'getContractsListModal',
      'getContractsListPagination',
      'getContractsListResponseModal',
      'getContractsListSearchValue',
      'getContractsListTableHeaders'
    ]),
    modal () {
      return this.getContractsListModal
    },
    currentUser () {
      return this.$store.getters.currentUser
    },
    tableHeader () {
      return this.getContractsListTableHeaders
    },
    contracts () {
      return this.getContractsList.map(contract => {
        return {
          id: contract.id,
          isActive: contract.isActive,
          values: [
            // { data: contract.id, mod: '' },
            { data: contract.partner?.long_name, mod: '' },
            { data: contract.project.name, mod: '' },
            { data: contract.treaty_number, mod: '' },
            { data: contract.type.name, mod: '' },
            { data: contract.start_date, mod: '' },
            { data: contract.term, mod: '' },
            { data: contract.amount, mod: '' },
            { data: contract.status?.name, mod: '' },
            { data: contract.stage, mod: 'colorText' },
            { data: contract.worker?.profile?.full_name, mod: '' }
          ]
        }
      })
    },
    searchValue () {
      return this.getContractsListSearchValue
    },
    filter () {
      return this.getContractsListFilter
    },
    pagination () {
      return this.getContractsListPagination
    },
    isLoading () {
      return this.getContractListIsLoading
    },
    deleteResponseModal () {
      return this.getContractsListResponseModal
    },
    isActiveDelete () {
      return this.getContractsListActiveDelete
    },
    roleAccessCreate () {
      return this.$store.getters.getRoleRightContracts.actions.add
    },
    roleAccessRemove () {
      return this.$store.getters.getRoleRightContracts.actions.remove
    },

    contractorOptionList () {
      return this.$store.getters.getContractContractorList
    },
    statusOptionList () {
      return this.$store.getters.getContractStatusList
    },
    projectOptionList () {
      return this.$store.getters.getContractProjectList
    },
    typeOptionList () {
      return this.$store.getters.getContractTypeList
    },
    stageOptionList () {
      return this.$store.getters.getContractStageList
    },
    assigneeOptionList () {
      return this.$store.getters.getContractAssigneeList
    }
  },
  methods: {
    goToUpdateContract (id) {
      this.$router.push({ name: 'ContractUpdate', params: { id } })
    },
    toggleItemControls (itemId) {
      this.$store.dispatch('contractListPage/toggleContractsListItemControls', itemId)
    },
    toggleActiveItem (itemId) {
      this.$store.dispatch('contractListPage/toggleContractsListItemActive', itemId)
    },
    toggleActiveAll () {
      this.$store.dispatch('contractListPage/toggleContractsListItemActiveAll')
    },
    saveContractItem () {
      this.$store.dispatch('contractListPage/saveContractsItem')
    },
    removeContract () {
      const itemId = this.removeConfirmation.id
      this.$store.dispatch('contractListPage/deleteContract', itemId)
      this.removeConfirmation.active = false
      this.removeConfirmation.id = null
      this.removeConfirmation.group = false
    },
    closeModalRemove () {
      this.removeConfirmation.active = false
      this.removeConfirmation.id = null
      this.removeConfirmation.group = false
    },
    closeModal () {
      this.$store.dispatch('contractListPage/closeContractsModal')
    },
    showRemoveConfirmation (itemId) {
      this.removeConfirmation.active = true
      this.removeConfirmation.id = itemId
    },
    closeRemoveConfirmation () {
      this.removeConfirmation.active = false
      this.removeConfirmation.id = null
    },
    showRemoveConfirmationGroup () {
      this.removeConfirmation.active = true
      this.removeConfirmation.id = null
      this.removeConfirmation.group = true
    },
    deleteContractsChecked () {
      this.removeConfirmation.active = false
      this.$store.dispatch('contractListPage/deleteContractsListCheckedItems')
      this.removeConfirmation.group = false
    },
    closeDeleteModal () {
      this.$store.dispatch('contractListPage/closeContractsListDeleteModal')
    },
    downloadExcel () {
      this.$store.dispatch('contractListPage/exportContractsListExcel')
    },

    // search
    setSearchValue (value) {
      this.$store.dispatch('contractListPage/setContractsListSearchValue', value)
    },

    // filter
    toggleFilter () {
      this.filterIsActive = !this.filterIsActive
    },
    searchContractor (value) {
      this.$store.dispatch('contractListPage/getSearchContractContractorsList', value)
    },
    searchProject (value) {
      this.$store.dispatch('contractListPage/getSearchContractProjectList', value)
    },
    setFilter (data) {
      console.log(data)
      const filter = {
        ProjectId: data.project?.id,
        StageId: data.stage?.id,
        StartDate: data.startDate,
        StatusId: data.status?.id,
        TreatyNumber: data.contractNumber,
        TypeId: data.type?.id,
        Amount: data.sum,
        FinishDate: data.endDate,
        PartnerId: data.contractor?.id,
        WorkerId: data.assignee?.id
      }
      this.$store.commit('contractListPage/SET_CONTRACTS_LIST_FILTER', filter)
      this.$store.dispatch('contractListPage/getContractsListPage', 1)
      this.$store.dispatch('contractListPage/getContracts')
    },
    clearFilter () {
      this.$refs.filterForm.clear()
      this.$store.commit('contractListPage/SET_CONTRACTS_LIST_FILTER', {})
      this.$store.dispatch('contractListPage/getContracts')
    },

    // pagination
    getPage (pageNum) {
      this.$store.dispatch('contractListPage/getContractsListPage', pageNum)
    }
  },

  mounted () {
    this.$store.dispatch('contractListPage/getContracts')
    this.$store.dispatch('getContractAllOptions')
    this.$store.dispatch('getContractUsers')
  },

  destroyed () {
    this.$store.commit('contractListPage/RESET_CONTRACTS_LIST_STORE')
  }
}
</script>

<style lang="scss" scoped>
@import '../../assets/css/system/_vars';
@import '../../assets/css/system/_mixins';

.page__export {
  margin-right: 16px;
  margin-left: auto;
}

.page__item {
  margin-right: 16px;

  @media screen and (max-width: 1200px) {
    margin-right: 8px;
  }
}
.no-records {
  margin-top: 80px;
  align-items: center;
  width: 100%;
  display: flex;
}

.contract__filter {
  background: #f3f5ff;

  .contract__filter-fields {
    display: grid;
    grid-template-columns: 1fr 1fr 1fr;
    column-gap: 26px;
    row-gap: 16px;
    padding: 0 30px;
    margin-top: 30px;
    //margin-right: 30px;
    max-height: 270px;
    overflow: auto;

    @media screen and (max-width:1260px) {
      column-gap: 16px;
    }

    &::-webkit-scrollbar {
      width: 8px;
      height: 10px;
    }

    &::-webkit-scrollbar-track {
      background-color: $color_third;
    }

    &::-webkit-scrollbar-thumb {
      background-color: $color_second-light;
      min-width: 300px;
    }
  }
  .contract__filter-buttons {
    display: flex;
    column-gap: 10px;
    padding: 20px;
    margin-top: 20px;
    background: white;
  }
}
.table__buttons {
  margin-bottom: 0;
}
</style>
